module.exports = __webpack_public_path__ + "media/src/images/icons/home/red-920632b178286fe5ee2e159d7b2a1806.svg";